<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deletePopup()">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div>
            <v-data-table
                :headers="headers"
                :items="paginateAllPopups"
                no-results-text="Herhangi bir sonuç bulunamadı..."
                disable-pagination
                :hide-default-footer="true"
                :server-items-length="meta_popup.total"
                @update:options="sort"
            >
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Popuplar</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-col sm="1">
                            <b-form-select 
                                v-model="pageSize" 
                                :options="pageSizes" 
                                @change="handlePageSizeChange"
                            ></b-form-select>
                        </v-col>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        {{ meta_popup.total }} kayıt
                        <v-divider class="mx-4" inset vertical></v-divider>
                        {{ meta_popup.from }} - {{ meta_popup.to }}
                        <v-divider class="mx-4" inset vertical></v-divider>
                        
                        <b-button
                            v-if="hasPermission('popups.create')"
                            size="sm"
                            variant="primary"
                            @click="addPopup()"
                        >
                            YENİ KAYIT
                        <i class="la la-plus"></i>
                        </b-button>

                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Araştır"
                            single-line
                            hide-details
                            @input="searchTable"
                        ></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="m-demo__preview m-demo__preview--btn">
                        <v-icon
                            class="la la-eye"
                            data-toggle="m-popover" title="Görüntüle"
                            @click="viewPopup(item.id)"
                        >
                        </v-icon>
        
                        <v-icon v-if="hasPermission('popups.update')"
                            class="la la-edit"
                            data-toggle="m-popover" title="Güncelle"
                            @click="editPopup(item.id)"
                        >
                        </v-icon>

                        <v-icon v-if="hasPermission('popups.delete')"
                            class="la la-trash"
                            data-toggle="m-popover" title="Sil"
                            @click="showDeleteDialog(item.id)"
                        >
                        </v-icon>

                        
                    </div>    
                </template>

                <template v-slot:[`item.is_active`]="{item}">
                    <b-badge class="mr-1" :variant="getClass(item.is_active)">{{ getText(item.is_active) }}</b-badge>
                </template>

                <template v-slot:[`item.start_date`]="{ item }">
                    <span>{{ item.start_date | formatDateTime }}</span>
                </template>

                <template v-slot:[`item.end_date`]="{ item }">
                    <span>{{ item.end_date | formatDateTime }}</span>
                </template>
                
                <template v-slot:[`item.created_at`]="{ item }">
                    <span>{{ item.created_at | formatDateTime }}</span>
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                    <span>{{ item.updated_at | formatDateTime }}</span>
                </template>


                <template v-slot:footer>
                    <v-toolbar flat>
                        <template>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <b-pagination
                                        v-model="page"
                                        :total-rows="meta_popup.total"
                                        :per-page="itemsPerPage"
                                        size="lg"
                                        @input="handlePageChange"
                                        align="right"
                                        first-number
                                        last-number
                                    ></b-pagination>
                                </v-col>
                            </v-row>
                        </template>
                    </v-toolbar>
                </template>
            
            </v-data-table>
        </div>
        
        <br />
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
          
    </div>
    
</template>

<script>

import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import { PAGINATE_ALL_POPUPS } from "@/core/services/store/popups.module";
import { DELETE_POPUP } from "@/core/services/store/popups.module";

export default {
    name: "popups-list",
    data() {
        return {
            title: "",
            search: "",
            dialog: false,
            itemToDelete: "",
            page: 1,
            itemsPerPage: 10,
            pageSize: 10,
            pageSizes: [10, 25, 50, 100],
            totalPages: 0,
            currentPage: 1,
            total: 0,
            from: 0, 
            to: 0,
            sortBy: 'updated_at',
            sortDesc: true,
            timer: null,
            row: false,
            headers: [
                { text: "İşlemler", value: "actions", sortable: false },
                { text: "ID", align: "start", value: "id" },
                { text: "Başlık", align: "start", value: "title" },
                { text: "Gösterileceği Sayfalar", align: "start", value: "display_pages" },
                { text: "Başlangıç Tarihi", align: "start", value: "start_date" },
                { text: "Bitiş Tarihi", align: "start", value: "end_date" },
                { text: "Aktif mi?", align: "start", value: "is_active" },
                { text: "Ekleyen", value: "user_created_name[0].name" },
                { text: "Ekleme Tarihi", value: "created_at" },
                { text: "Güncelleyen", value: "user_updated_name[0].name" },
                { text: "Güncelleme Tarihi", value: "updated_at" }
            ],
        };
    },

    methods: {
        handlePageChange(value) {
            this.currentPage = value;
            this.paginate();
        },

        searchTable(value){
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = value;
                this.paginate();
            }, 500);
        },

        sort(options){
            this.sortBy = options.sortBy;
            this.sortDesc = options.sortDesc;
            this.paginate();
        },

        handlePageSizeChange(size) {
            this.pageSize = size;
            this.itemsPerPage = size;
            this.page = 1;
            this.paginate();
        },
        
        showDeleteDialog(id) {
            this.itemToDelete = id
            this.dialog = !this.dialog
        },

        addPopup() {
            this.$router.push({
                name: "popups-form",
                params: { formType: "add"}
            });
        },

        editPopup(id) {
            this.$router.push({
                name: "popups-form",
                params: { id: id, formType: "edit" }
            });
        },

        viewPopup(id) {
            this.$router.push({
                name: "popups-form",
                params: { id: id, formType: "view" }
            });
        },
        
        deletePopup() {
            this.dialog = false;
            
            var itemToDelete = this.itemToDelete;
            this.$store.dispatch(DELETE_POPUP, {
                    itemToDelete
                });
            this.paginate();
        },
        paginate() {
            var pageNumber = this.page;
            var itemsPerPage = this.itemsPerPage;
            var sortBy = this.sortBy;  
            var sortDesc = this.sortDesc; 
            var search = this.search;
            var x = 1;

            this.$store.dispatch(PAGINATE_ALL_POPUPS, {
                    itemsPerPage, 
                    pageNumber, 
                    sortBy, 
                    sortDesc, 
                    search,
                    x
                });
            },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },
        
        getClass(id) {
            if (id == 1) return 'primary'
            else return 'secondary'
        },

        getText(id) {
            if (id == 1) return 'Aktif'
            else return 'Pasif'
        }
        
        },
    created(){
        this.$store.dispatch('getUserMenu');
        
    },

    
    computed: {
        
        ...mapGetters(["paginateAllPopups", "meta_popup", "currentUserMenu"]),
        
        ...mapState({
            loading: state => state.popups.loading,
        }),
        
    },

};
</script>
